import React, { useState, useEffect } from 'react';
import { fetchDashboardData } from '../../services/api';
import Filters from './Filters';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SummaryCards from './SummaryCards';
import TimeSeriesChart from './TimeSeriesChart';
import HierarchyChart from './HierarchyChart';
import FinancialAnalysis from './FinancialAnalysis';
import DataTable from './DataTable'; 
import AttendanceSegmentation from './AttendanceSegmentation';
import Loader from '../UI/Loader';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    archdeaconry: '',
    parish: '',
    congregation: '',
    start_date: '',
    end_date: '',
    data_type: ''
  });

    // 🧠 Select the correct dataset based on the filter type
  let selectedTimeSeries = [];

  if (filters.data_type === 'attendance') {
    selectedTimeSeries = dashboardData?.time_series_attendance || [];
  } else if (filters.data_type === 'collections') {
    selectedTimeSeries = dashboardData?.time_series_collections || [];
  } else if (filters.data_type === 'all' || filters.data_type === '') {
    selectedTimeSeries = [
      ...(dashboardData?.time_series_attendance || []),
      ...(dashboardData?.time_series_collections || []),
    ];
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const data = await fetchDashboardData(filters);
        setDashboardData(data);
      } catch (err) {
        if (err.response?.status === 404) {
          toast.info('No data found for the selected filters');
          setDashboardData(null);
        } else {
          toast.error('Failed to load dashboard data');
        }
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [filters]);

  if (loading && !dashboardData) return <Loader />;

  return (
    <div className="container my-4">
      <h1 className="text-center text-dark mb-4">
        Church Attendance Analytics Dashboard
      </h1>
      
      <Filters 
        onFilterChange={setFilters} 
        initialFilters={filters} page="dashboard"
      />

      {dashboardData && (
        <>
          <SummaryCards data={{ attendance: dashboardData.attendance_overall, financial: dashboardData.financial_overall }} filters={filters} />
          
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="card-title border-bottom pb-2">Time Series Analysis</h5>
              <TimeSeriesChart data={selectedTimeSeries} filters={filters} />
            </div>
          </div>

          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="card-title border-bottom pb-2">Hierarchy Overview</h5>
              <HierarchyChart data={dashboardData} filters={filters} /> 
            </div>
          </div>
      
          {filters.data_type !== 'attendance' && dashboardData?.financial_analysis && (
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title border-bottom pb-2">Financial Analysis</h5>
                <FinancialAnalysis data={dashboardData.financial_analysis} filters={filters} />
              </div>
            </div>
          )}

          {filters.data_type !== 'collections' && dashboardData?.attendance_segmentation && (
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title border-bottom pb-2">Attendance Segmentation</h5>
                <AttendanceSegmentation data={dashboardData.attendance_segmentation} filters={filters} />
              </div>
            </div>
          )}


          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="card-title border-bottom pb-2">Detailed Data</h5>
              <DataTable filters={filters} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
